module.exports = __webpack_public_path__ + "img/1569866353.4ab98095.jpg";